import store from '@/store/index'

const {body} = document;
const WIDTH = 992;

export default {
    watch: {
        // eslint-disable-next-line no-unused-vars
        $route(route) {
            // 如果侧边栏打开
            if (this.device === 'mobile' && this.sidebar.opened) {
                store.dispatch('app/closeSideBar', {withoutAnimation: false})
            }
        }
    },
    beforeMount() {
        // 添加事件监听
        window.addEventListener('resize', this.$_resizeHandler)
    },
    beforeDestroy() {
        // 删除事件监听
        window.removeEventListener('resize', this.$_resizeHandler)
    },
    mounted() {
        const isMobile = this.$_isMobile();
        if (isMobile) {
            // 改变弹窗大小
            // store.dispatch("app/Fullscreen");
            store.dispatch('app/toggleDevice', 'mobile');
            store.dispatch('app/closeSideBar', {withoutAnimation: true})
        }
    },
    methods: {
        $_isMobile() {
            // 获取某个元素相对于视窗的位置集合
            const rect = body.getBoundingClientRect();
            return rect.width - 1 < WIDTH
        },
        $_resizeHandler() {
            if (!document.hidden) {
                const isMobile = this.$_isMobile();
                store.dispatch('app/toggleDevice', isMobile ? 'mobile' : 'desktop');
                if (isMobile) {
                    store.dispatch('app/closeSideBar', {withoutAnimation: true})
                }
            }
        }
    }
}
